import {AsyncTypeahead, Typeahead} from 'react-bootstrap-typeahead'
import {Modal, Grid, Col, Row} from 'react-bootstrap'
import {request} from '../../helpers/request'
import {t} from '../../helpers/translate'
import React from 'react'
import {getTrackingCode} from '../../helpers/access'
let config = require('config');

class SalesChannelModalComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      affiliateCandidates: [],
      currentAffiliate: null,
      currentSaleChannel: '',
      isLoading: false,
      saleChannels: [
        {'key': t('Phone'), 'value': 'phone'},
        {'key': t('Email'), 'value': 'email'},
        {'key': t('Mail'), 'value': 'mail'},
        {'key': t('Walk-In'), 'value': 'walkin'},
      ]
    };
    this.onTypeAffiliateDropDown = this.onTypeAffiliateDropDown.bind(this);
    this.onFindAffiliateResponse = this.onFindAffiliateResponse.bind(this);
    this.openForm = this.openForm.bind(this);
  }

  openForm(event) {
    if (!this.state.currentSaleChannel) {
      return;
    }
    const baseUrl = this.props.baseUrl;
    const halfUrl = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${this.getSalesChannel()}${getTrackingCode()}`;
    const finalUrl = `${halfUrl}&affiliate_code=${this.state.currentAffiliate}`;
    window.open(this.state.currentAffiliate ? finalUrl : halfUrl);
    this.setState({currentSaleChannel: ''})
    this.props.hideModal();
  }

  getSalesChannel() {
    return `sales_channel=${this.state.currentSaleChannel}`;
  }

  onFindAffiliateResponse(data, statusCode) {
    this.setState({
      affiliateCandidates: data['affiliates'],
      isLoading: false
    });
  }

  onTypeAffiliateDropDown(text) {
    if (text.length < 3) {
      this.setState({currentAffiliate: null});
      return;
    }
    this.setState({
      isLoading: true
    });

    request(`${config.default.api}/affiliate?name=${text}`, 'GET', null, this.onFindAffiliateResponse);
  }

  render() {
    const csrToken = sessionStorage.getItem('csr_token');
    return <Modal id='salesChannelModal' bsSize='small' show={this.props.showModal} onHide={this.props.hideModal} backdrop='static'>
      <Modal.Header>
        <Modal.Title>{t('Select Sales Channel')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Grid>
          <Row className='show-grid'>
            <Col lg={1}>{t('Sales Channel')}</Col>
            <Col lg={1}>
              <Typeahead
                bsSize='sm'
                className='salesChannelList'
                filterBy={(option, text) => option}
                labelKey={saleChannel => `${saleChannel.key}`}
                onChange={(selected) => this.setState({currentSaleChannel: selected[0].value})}
                options={this.state.saleChannels}
                placeholder={t('Required')}
              />
            </Col>
          </Row>
          <Row className='show-grid'>
            <Col lg={1}>{t('CSR')}</Col>
            <Col lg={9}>{csrToken ? csrToken : t('CSR')}</Col>
          </Row>
          <Row className='show-grid'>
            <Col lg={1}>{t('Affiliate')}</Col>
            <Col lg={9}>
              <AsyncTypeahead
                className='affiliateList'
                bsSize='sm'
                isLoading={this.state.isLoading}
                labelKey={affiliate => `${affiliate['long_name']}, ${affiliate['short_name']}, ${affiliate['code']}`}
                onChange={(selected) => this.setState({currentAffiliate: selected.length>0 ? selected[0]['long_name'] : null})}
                onSearch={this.onTypeAffiliateDropDown}
                options={this.state.affiliateCandidates}
                placeholder={t('Enter Affiliate')}
              />
            </Col>
          </Row>
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn button-primary" onClick={this.props.hideModal}>{t('Cancel')}</button>
        <button className="btn button-secondary" onClick={this.openForm}>{t('Proceed')}</button>
      </Modal.Footer>
    </Modal>;
  }
}

SalesChannelModalComponent.displayName = 'SalesChannelModalComponent';
export default SalesChannelModalComponent;



// WEBPACK FOOTER //
// ./src/components/common/SalesChannelModalComponent.js